import { Link, useLocation } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
import { useHeaderNav } from '../../contexts/SiteContext';
import { useAuth } from '../../contexts/AuthContext';
import { useViewTransition } from '../../hooks/useViewTransition';
import type { CmsNavItem } from '../../types/cms';

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

export function MobileMenu({ isOpen, onClose }: MobileMenuProps) {
  const headerItems = useHeaderNav();
  const { isAuthenticated, logout } = useAuth();
  const location = useLocation();
  const navigate = useViewTransition();

  if (!isOpen) return null;

  const handleNavClick = (item: CmsNavItem) => {
    onClose();
    if (!item.isExternal) {
      navigate(item.path);
    }
  };

  const handleLogout = async () => {
    onClose();
    await logout();
    navigate('/login');
  };

  return (
    <div className="sm:hidden bg-white border-b border-zinc-100 z-40">
      <nav className="px-4 py-3 space-y-0.5">
        {headerItems.map((item) =>
          item.isExternal ? (
            <a
              key={item.id}
              href={item.path}
              target="_blank"
              rel="noopener noreferrer"
              onClick={onClose}
              className="flex items-center gap-2 px-3 py-2.5 rounded-lg text-sm font-medium text-zinc-600 hover:bg-zinc-50 hover:text-zinc-900 transition-colors"
            >
              {item.label}
              <ExternalLink size={12} className="text-zinc-400" />
            </a>
          ) : (
            <button
              key={item.id}
              onClick={() => handleNavClick(item)}
              className={[
                'flex items-center gap-2 px-3 py-2.5 w-full text-left rounded-lg text-sm font-medium transition-colors',
                location.pathname === item.path
                  ? 'bg-[--color-primary] text-white'
                  : 'text-zinc-600 hover:bg-zinc-50 hover:text-zinc-900',
              ].join(' ')}
            >
              {item.label}
            </button>
          ),
        )}

        {headerItems.length > 0 && (
          <div className="pt-1 border-t border-zinc-100" />
        )}

        {isAuthenticated ? (
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 px-3 py-2.5 w-full text-left rounded-lg text-sm font-medium text-zinc-500 hover:bg-zinc-50 hover:text-zinc-900 transition-colors"
          >
            Esci
          </button>
        ) : (
          <button
            onClick={() => { onClose(); navigate('/login'); }}
            className="flex items-center gap-2 px-3 py-2.5 w-full text-left rounded-lg text-sm font-medium text-zinc-600 hover:bg-zinc-50 hover:text-zinc-900 transition-colors"
          >
            Accedi
          </button>
        )}
      </nav>
    </div>
  );
}
